import { render } from "./UCProductionElement.vue?vue&type=template&id=6d2d8ffd&scoped=true"
import script from "./UCProductionElement.vue?vue&type=script&lang=js"
export * from "./UCProductionElement.vue?vue&type=script&lang=js"

import "./UCProductionElement.vue?vue&type=style&index=0&id=6d2d8ffd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2d8ffd"]])

export default __exports__